import { useEffect, useState } from "react"
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای نمایش صفحه بندی جدول است
 */
export default function Pagination({ handelprevpage, handelNextpage, totalPage, page, handelpagenumber }) {

    const [arrypages, setArrypages] = useState([])
    const [arrymore, setArrymore] = useState([])
    const [arrylength, setArrylength] = useState(JSON.parse(sessionStorage.getItem('Pagination')) || [])


    const handelmore = () => {
        window.scroll(0, 10)
        if (arrylength.length > 0) {
            sessionStorage.setItem('Pagination', JSON.stringify(arrypages.slice(arrylength[0] + 4, arrylength[4] + 5)))

            setArrylength(arrypages.slice(arrylength[0] + 4, arrylength[4] + 5))
        }
        else {
            setArrymore(arrypages.slice(arrymore[0] + 4, arrymore[4] + 5))
        }
    }

    const handelpage = (number) => {

        window.scroll(0, 10)

        handelpagenumber(number)
        if (number === 1 || number < 5) {
            setArrymore([1, 2, 3, 4, 5])
            setArrylength([])
            sessionStorage.setItem('Pagination', JSON.stringify([]))

        }

        else {
            sessionStorage.setItem('Pagination', JSON.stringify(arrypages.slice(number - 4, number + 1)))

            setArrylength(arrypages.slice(number - 4, number + 1))
        }

    }


    useEffect(() => {

        if (arrylength.length > 0) {
            if (arrylength.find(item => item === parseInt(page)) === undefined) {
                setArrylength(arrypages.slice(parseInt(page) - 1, parseInt(page) + 4))
                sessionStorage.setItem('Pagination', JSON.stringify(arrypages.slice(parseInt(page) - 1, parseInt(page) + 4)))

            }
        }
        return () => {

        }
    }, [arrylength, page])

    useEffect(() => {

        let arrypagese = []


        if (totalPage) {
            for (let index = 0; index < totalPage; index++) {
                arrypagese.push(index + 1)

            }
            setArrypages(arrypagese)
            setArrymore(arrypagese.slice(0, 5))
        }
    }, [totalPage])

    return (
        <nav>

            {arrypages.length < 6 ?
                <ul className="pagination flex-wrap p-0"  >
                    <li className="page-item" onClick={handelprevpage} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-right"></i></span></li>
                    {arrypages.map(item => (

                        <li key={item.toString()} onClick={() => handelpagenumber(item)}
                            className={item === parseInt(page) ? "page-item active" : "page-item"}>
                            <span className="page-link" href="#">{item.toString()}</span>
                        </li>

                    ))} <li className="page-item" onClick={handelNextpage} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-left"></i></span>
                    </li>
                </ul>
                :
                <ul className="pagination flex-wrap p-0"  >
                    <li className="page-item" onClick={() => handelpage(1)} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-double-right"></i>
                        </span>
                    </li>
                    <li className="page-item" onClick={handelprevpage} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-right"></i>
                        </span>
                    </li>
                    {

                        arrylength.length > 0 ?
                            arrylength.map(item => (

                                <li key={item.toString()} onClick={() => handelpage(item)}
                                    className={item === parseInt(page) ? "page-item active" : "page-item"}>
                                    <span className="page-link" href="#">{item.toString()}</span>
                                </li>))
                            :
                            arrymore.map(item => (

                                <li key={item.toString()} onClick={() => handelpage(item)}
                                    className={item === parseInt(page) ? "page-item active" : "page-item"}>
                                    <span className="page-link" href="#">{item.toString()}</span>
                                </li>

                            ))
                    }
                    <li className="page-item" onClick={handelmore} ><span className="page-link" href="#">...</span></li>
                    <li className="page-item" onClick={handelNextpage} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-left"></i>
                        </span>
                    </li>
                    <li className={totalPage === parseInt(page) ? "page-item active" : "page-item"}
                        onClick={() => handelpage(totalPage)} >
                        <span className="page-link" href="#">
                            <i className="mdi mdi-chevron-double-left"></i>
                        </span>
                    </li>
                </ul>
            }

        </nav>
    )
}
Pagination.propTypes = {
    handelprevpage: PropTypes.func,
    handelNextpage: PropTypes.func,
    /**تعداد کل صفحات جدول */
    totalPage: PropTypes.number,
    /**صفحه فعلی جدول */
    page: PropTypes.number,
    /**ارسال صفحه به بالا */
    handelpagenumber: PropTypes.func,
}